<template>
  <div id="login">
    <div class="loginbox">
      <div class="tabbox clearfix">
        <div class="item" :class="active ===1 ? 'active' : ''" @click="changeLogin(1)">学生登录</div>
        <div class="item" :class="active ===2 ? 'active' : ''" @click="changeLogin(2)">教师登录</div>
        <div class="item" :class="active ===3 ? 'active' : ''" @click="changeLogin(3)">家长登录</div>
      </div>
      <div class="inputbox">
        <Form ref="formInline" :model="formInline" :rules="ruleInline" inline>
            <p class="error">{{errorText}}</p>
            <FormItem prop="user">
                <Input type="text" v-model="formInline.user" :placeholder="stuplaceholder"></Input>
            </FormItem>
            <FormItem prop="password">
                <Input type="password" v-model="formInline.password" placeholder="密码"></Input>
            </FormItem>
            <FormItem>
                <Button type="primary" @click="handleSubmit('formInline')">立即登录</Button>
            </FormItem>
        </Form>
        <div class="forgetbox">
        <a href="">忘记密码？</a>
        </div>
        <div class="cancel" @click="cancelLogin">取消登录</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name:'login',
    data() {
      return {
        active:1,
        stuplaceholder:'手机号/邮箱/用户名/学号',
        errorText:'',
        formInline: {
            user: '',
            password: ''
        },
        ruleInline: {
            user: [
                { required: true, message: '请填写帐号', trigger: 'blur' }
            ],
            password: [
                { required: true, message: '请填写密码', trigger: 'blur' },
                { type: 'string', min: 6, max:18, message: '密码不少于6位不多于18位', trigger: 'blur' }
            ]
        }
      }
    },
    watch:{

    },
    mounted() {

    },
    methods:{
      changeLogin(id){
        this.active = id;
        if(id ==1){
          this.stuplaceholder = '手机号/邮箱/用户名/学号'
        }else if(id ==2){
          this.stuplaceholder = '手机号/邮箱/用户名/工号'
        }else if(id == 3){
          this.stuplaceholder = '手机号/邮箱/用户名/帐号'
        }
      },
      handleSubmit(name) {
        this.$refs[name].validate((valid) => {
            if (valid) {
                this.$Message.success('Success!');
                console.log(this.formInline)
            } else {
                this.$Message.error('Fail!');
            }
        })
      },
      cancelLogin(){
        this.$emit('cancelbtn',false)
      }
    }
  }
</script>
<style>
  .inputbox input {
    height: 40px;
  }
  .inputbox form {
    width: 335px;
    margin: 0 auto;
    position: relative;
  }
  .inputbox form button {
    width: 100%;
    height: 40px;
    line-height: 40px;
  }
  .inputbox .ivu-form-inline .ivu-form-item {
    display: block;
  }
  .inputbox .ivu-form-inline .ivu-form-item:last-of-type {
    margin-bottom: 0;
  }
</style>
<style scoped>
#login {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99;
}
.loginbox {
  width: 399px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
  background-color: #fff;
  overflow: hidden;
}
.item {
  float: left;
  height: 64px;
  background: #F2F2F2;
  width: 133px;
  border: 1px solid #D8D8D8;
  border-top: 0;
  line-height: 64px;
  color: #888888;
  cursor: pointer;
}
.item.active {
  background-color: #fff;
  color: #333333;
  border-bottom: 0;
}
.inputbox {
  margin-top: 30px;
}
.error {
  position: absolute;
  left: 0;
  top: -25px;
  color: #FF333E;
  font-size: 14px;
}
.forgetbox {
  margin: 10px auto ;
  width: 335px;

  height: 20px;
}
.forgetbox a {
  color: #9A9A9A;
  font-size: 14px;
  float: right;
}
.cancel {
  color: #3583FF;
  margin:30px auto;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/indexContent/login.vue